import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { HexPillModule } from "@hex/angular/pill";
import { CommonUtilsModule } from "../common-utils/common-utils.module";

import { CommonStaticFilterActionsDirective } from "./actions.directive";
import { CommonStaticFilterComponent } from "./common-static-filter.component";
import { staticFilterStatePropProvider } from "./state-props";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CommonUtilsModule,
        HexPillModule,
    ],
    exports: [
        CommonStaticFilterComponent,
        CommonStaticFilterActionsDirective,
    ],
    declarations: [
        CommonStaticFilterComponent,
        CommonStaticFilterActionsDirective,
    ],
    providers: [
        CommonStaticFilterActionsDirective,
        staticFilterStatePropProvider,
    ],
})
export class CommonStaticFilterModule {
}
